let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ZGwi")).then(() => parcelRequire('aX5Qn'));